import React from 'react';
import Image from './image';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import WarningMessageHeader from './warningMessageHeader';
import Dropdown from 'react-bootstrap/Dropdown';
import {handleClick}  from "../utils/event_handling";
import HelpZendesk from "./help.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from "react-redux";
import {browserHistory} from 'react-router';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {
    //faBell, 
    faUser, faChartPie, faHistory, faUserPlus, faServer,
    faUserCog, faUserFriends, faSignOutAlt, faBezierCurve, faDatabase,
    faShoppingBag, faExclamationTriangle, faArrowRight, faHdd, 
    // faQuestion,
    //faHeadset,
     faBook, faDollarSign, faRocket, faUserMinus, faSearch, faSun, faMoon, faDesktop} from '@fortawesome/free-solid-svg-icons';
import { getApi } from "../utils/event_handling";
import $ from "jquery";
import { Link } from 'react-router';
// import OfflineComponent from './offlineComponent'
// import { Offline } from "react-detect-offline";
import ProgressLoader from './progressLoader';
import {get_document_link, getTrimmedNotificationMessage, getFeatureAccess, decryptForLocalUsage} from "../utils/common_utils";
import {IS_NONE_CHECK, REQUIRES_EXCLAMATION_TRIANGLE_ICON,
        LOCAL_STORE_KEY, QUALDO_DOCUMENTATION, PERMISSIONS_LOCAL_STORE_KEY} from "../utils/constant";
// import InternetStatusAlert from './internetStatusAlert';
import NetworkStatusAlert from './NetworkStatusAlert';
// import AiAssistant from './ai-assistant.js';


const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];

const userToggle = React.forwardRef(({ children, onClick }, ref) => (
    <span
        href=""
        ref={ref}
        className="qd-header__topbar-icon dropdown-toggle"
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        <FontAwesomeIcon color="#fff" icon={faUser} />
        {children}
    </span>

));

/*
const helpToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
    className="qd-header__topbar-icon"
    onClick={(e) => {
        e.preventDefault();
        onClick(e);
    }}
    >
        <span className="nav-link">
            <FontAwesomeIcon color="#fff" icon={faQuestion}/>
            {children}
        </span>
    </div>
  ));
  */

const customLink = React.forwardRef(({link, tab, children, onClick}, ref) => (
    <Link to={link} className={link.includes(tab) ? "dropdown-item active" : "dropdown-item"}>
        {children}
    </Link>
));

const goToNotifications = () => {
    window.location.href = "/notification";
}
const bellToggle = React.forwardRef(({ children, onClick, unReadMsg }, ref) => {

    if (unReadMsg != null && unReadMsg.length > 0) {
        return (<span
            ref={ref}
            className="qd-header__topbar-icon"
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 19.3845C5.0375 19.3845 4.85942 19.3127 4.71575 19.169C4.57192 19.0252 4.5 18.8469 4.5 18.6343C4.5 18.4218 4.57192 18.2437 4.71575 18.1C4.85942 17.9565 5.0375 17.8848 5.25 17.8848H6.30775V10.423C6.30775 9.07817 6.72283 7.88908 7.553 6.85575C8.383 5.82242 9.44867 5.1615 10.75 4.873V4.25C10.75 3.90283 10.8714 3.60767 11.1143 3.3645C11.3571 3.1215 11.6519 3 11.9988 3C12.3458 3 12.641 3.1215 12.8845 3.3645C13.1282 3.60767 13.25 3.90283 13.25 4.25V4.873C14.5513 5.1615 15.617 5.82242 16.447 6.85575C17.2772 7.88908 17.6923 9.07817 17.6923 10.423V17.8848H18.75C18.9625 17.8848 19.1406 17.9566 19.2843 18.1003C19.4281 18.2441 19.5 18.4223 19.5 18.635C19.5 18.8475 19.4281 19.0256 19.2843 19.1693C19.1406 19.3128 18.9625 19.3845 18.75 19.3845H5.25ZM11.9983 22.1923C11.5008 22.1923 11.0754 22.0153 10.7223 21.6613C10.3689 21.3073 10.1923 20.8817 10.1923 20.3845H13.8077C13.8077 20.8833 13.6306 21.3093 13.2762 21.6625C12.9219 22.0157 12.4959 22.1923 11.9983 22.1923ZM7.80775 17.8848H16.1923V10.423C16.1923 9.26533 15.783 8.27725 14.9645 7.45875C14.1458 6.64008 13.1577 6.23075 12 6.23075C10.8423 6.23075 9.85417 6.64008 9.0355 7.45875C8.217 8.27725 7.80775 9.26533 7.80775 10.423V17.8848Z" fill="white"/>
            </svg>
            {children}
        </span>
        );
    } else {
        return (<span
            ref={ref}
            className="qd-header__topbar-icon"
            onClick={e => {
                e.preventDefault();
                goToNotifications();
            }}
        >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 19.3845C5.0375 19.3845 4.85942 19.3127 4.71575 19.169C4.57192 19.0252 4.5 18.8469 4.5 18.6343C4.5 18.4218 4.57192 18.2437 4.71575 18.1C4.85942 17.9565 5.0375 17.8848 5.25 17.8848H6.30775V10.423C6.30775 9.07817 6.72283 7.88908 7.553 6.85575C8.383 5.82242 9.44867 5.1615 10.75 4.873V4.25C10.75 3.90283 10.8714 3.60767 11.1143 3.3645C11.3571 3.1215 11.6519 3 11.9988 3C12.3458 3 12.641 3.1215 12.8845 3.3645C13.1282 3.60767 13.25 3.90283 13.25 4.25V4.873C14.5513 5.1615 15.617 5.82242 16.447 6.85575C17.2772 7.88908 17.6923 9.07817 17.6923 10.423V17.8848H18.75C18.9625 17.8848 19.1406 17.9566 19.2843 18.1003C19.4281 18.2441 19.5 18.4223 19.5 18.635C19.5 18.8475 19.4281 19.0256 19.2843 19.1693C19.1406 19.3128 18.9625 19.3845 18.75 19.3845H5.25ZM11.9983 22.1923C11.5008 22.1923 11.0754 22.0153 10.7223 21.6613C10.3689 21.3073 10.1923 20.8817 10.1923 20.3845H13.8077C13.8077 20.8833 13.6306 21.3093 13.2762 21.6625C12.9219 22.0157 12.4959 22.1923 11.9983 22.1923ZM7.80775 17.8848H16.1923V10.423C16.1923 9.26533 15.783 8.27725 14.9645 7.45875C14.1458 6.64008 13.1577 6.23075 12 6.23075C10.8423 6.23075 9.85417 6.64008 9.0355 7.45875C8.217 8.27725 7.80775 9.26533 7.80775 10.423V17.8848Z" fill="white"/>
            </svg>
            {children}
        </span>
        );
    }
  },
);
const envToggle = React.forwardRef(({ onClick, selectedEnv, latestEnvName }, ref) => (
    <div
        ref={ref}
        className="qd-env-dropdown__btn dropdown-toggle"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        <span className="env-tag"style={{backgroundColor: selectedEnv?.color,}}>
            {selectedEnv?.label? selectedEnv.label[0].toUpperCase(): latestEnvName?.[0]?.toUpperCase() || "E"}
        </span>
        {/* Add Loader when environment is loading */}
        {/* <span className="env-tag" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <Image className="d-block" width="20px" src={"icon_preloader"} />
        </span> */}
        <span className="env-info">
            <label>Environment</label>
            <strong className="env-name">{selectedEnv ? selectedEnv.label : latestEnvName || "Select Environment"}</strong>
            {/* Skeleton Loader */}
            {/* <span className="env-name pt-1"><Skeleton width="80px" height="12px" /></span> */}
        </span>
    </div>
));

let activeItems = {
    'configure': 'nav-item',
    'profile': 'nav-item',
    'monitor': 'nav-item',
    'metrics': 'nav-item',
    'alerts': 'nav-item',
    'discover': 'nav-item',
    'incidents': 'nav-item',
    'realtime': 'nav-item'
};
let SUB_BRAND = process.env.REACT_APP_CUSTOM_SUB_BRAND
let BRAND_LOGO = process.env.REACT_APP_CUSTOM_BRAND_LOGO
class NavigationHeader extends React.Component {
     constructor(props) {
            super(props);
            this.getApi = getApi.bind(this);
            this.handleHelp = this.handleHelp.bind(this);
            this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
            this.check_access_billing = this.check_access_billing.bind(this);
            this.closeWarning = this.closeWarning.bind(this);

            // this.handleEnvSearchChange = this.handleSearchChange.bind(this);
            // this.handleSearchChange = this.handleSearchChange.bind(this);

            this.handleEnvSelect = this.handleEnvSelect.bind(this);
            this.handleEnvSearchChange  = this.handleEnvSearchChange.bind(this);
            this.clearEnvSearch = this.clearEnvSearch.bind(this);
            let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
            let warning_message = decrypt_data['warning_message']
            // let warning_message = localStorage.getItem("warning_message");

            let showWarning = false;
            this.input = null;
            if (warning_message !== undefined && warning_message !== null && warning_message !== '' && warning_message !== 'undefined') {
                showWarning = true;
            }
            this.state = {
                unreadNotifications: null,
                featureAccess: getFeatureAccess(),
                selectedView : null,
                notificationLoaded: false,
                notificationType: null,
                selectedNotification: null,
                zendeskShow: false,
                showWarning: showWarning,
                warningMessage: warning_message,
                prefetch_load: this.props.prefetch_load === true ? this.props.prefetch_load : false,
                environment:[],
                //latest_env_name:this.props.selectedEnvName,
                // environment:
                // environment:this.props.environment,
                latest_env_name:this.props.latest_env_name,
                env_search_text:'',
                showAiAssistant: false,
                theme: localStorage.getItem("theme") || "light",
            }
            this.getNotificationHeaderData();
     }

     pageRefresh(internetstatus){
        if(internetstatus === true){
            window.location.reload(false);
        }
     }

     handleShowAiAssistant = () => {
        document.body.style.overflow = 'hidden';
        this.setState({showAiAssistant : true});
     }

     handleHideAiAssistant = () => {
        document.body.style.overflow = 'auto';
        this.setState({showAiAssistant : false});
     }

     handleEnvSearchChange = (event) => {
        let search_text = event.target.value.toLowerCase();
        this.setState({ env_search_text:search_text });

        let filteredEnv =  this.state.environment.filter(env =>
          env.label.toLowerCase().includes(search_text)
        );

        this.setState({ filteredEnv:filteredEnv });
      };

     handleEnvSelect(env, index,latest_env_name){
        this.props.callbackEnvironemnt(env)
        this.setState({
            selectedEnv: { ...env, color: colors[index % colors.length],},
          });
     }



     onKeyDownHandler = e => {
        if (e.keyCode === 13) {
          e.preventDefault();
          if(this.input.value.trim()){
              let data = {"search_text":this.input.value }
              browserHistory.push({
                  pathname: '/discover',
                    state: data // your data array of objects
                })
          }
        }
      };

     componentDidMount() {
        if(this.props.cachenable === true || this.props.discoverCache === true){   // Temp codition for avoid page break   need to remove later
            this.getApi("environments");
        }
        let header = $(".qd-header");
        let body = $("body");
        let shrinkIt = header.height();
        if (this.props.page === "realtime") {
        header.addClass("sticky-header");
        body.addClass("has-sticky-header");
        } else {
        // Scroll logic for other pages
        $(window).scroll(function () {
            let scroll = $(window).scrollTop();
            if (scroll >= shrinkIt) {
                header.addClass("sticky-header");
                body.addClass("has-sticky-header");
            } else {
                header.removeClass("sticky-header");
                body.removeClass("has-sticky-header");
            }
        });
    }
        $("#navBarToggler").click(function() {
            if ($("#navBarToggler").hasClass("collapsed")) {
                $("#navBarToggler").removeClass("collapsed");
                $("#navbarCollapse").addClass("show");
            } else {
                $("#navBarToggler").addClass("collapsed");
                $("#navbarCollapse").removeClass("show");
            }
        });

        //Start: Theme DOM Append
        document.documentElement.className = this.state.theme;  
        //End: Theme DOM Append
    }

    /* Start: Theme Switching Code */

    toggleTheme = (newTheme) => {
        if(newTheme !== this.state.theme) {
            this.setState({theme : newTheme});
        }
        this.setState({themeSystem : ''});
    };

    setSystemTheme = () => {
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const newTheme = prefersDarkMode ? 'dark' : 'light';
        this.setState({theme : newTheme, themeSystem : 'system'});
    };

    /* End: Theme Switching Code */

    static getDerivedStateFromProps(props, state) {
        const userNotificationDataFromProps = props.dataModule.userNotificationData;

        const currStateUnreads = state.unreadNotifications;
        const propsUnreadsCount = userNotificationDataFromProps.unreadNotifications.length;
        const unreadCountMisMatch = (currStateUnreads !== null) && (currStateUnreads.length !== propsUnreadsCount);

        const firstTimeLoading = state.notificationLoaded === false && userNotificationDataFromProps.loaded === true;

        if (firstTimeLoading || unreadCountMisMatch) {
            return {
                unreadNotifications: userNotificationDataFromProps.unreadNotifications,
                notificationLoaded: true
            };
        }

        return null;
    }

     goToTeamMate() {
        window.location.href = "/teammate";
     }

    getNotificationHeaderData() {
        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken === "undefined" || sessionToken === "null" ||
            sessionToken === null || sessionToken === undefined) {
            window.location = '/';
            return;
        }

    }


     handleHelp() {
         //this.setState({zendeskShow:true});
         window.zE(function() {
            window.zE.show();
            window.zE.identify({
                name: localStorage.getItem('user_name'),
                email: localStorage.getItem('emailId'),
            });
        });
        window.zE.activate({hideOnClose: false});
     }

     getErrorIcon(notification_type){
        if (notification_type === "Data Quality Error"){
           return faServer;
        }else if(notification_type === "Model Error"){
           return faHdd;
        }else if(notification_type === "Limit Exceeded Alert"){
           return faExclamationTriangle;
        }else if(notification_type === "Payment Failure Alert"){
           return faDollarSign;
        } else if (notification_type === "Missing Dataset"){
           return faServer;
        } else if (notification_type === "Schema Drift"){
           return faServer;
        } else {
            if (REQUIRES_EXCLAMATION_TRIANGLE_ICON.includes(notification_type)) {
                return faExclamationTriangle;
            }
        }
     }

    /* getNotificationSendTimeInMinutes(createdTimeString){
        let minutes = null;
        let hours = null;
        let days = null;
        var currentTime = new Date();
        var createdTime = new Date(createdTimeString);
        minutes = parseInt((currentTime-createdTime)/(60*1000));
        hours = parseInt((currentTime-createdTime)/(3600*1000));
        days = parseInt((currentTime-createdTime)/(24*3600*1000));
        if(minutes != null && minutes <= 60){
            return minutes + " Mins ago";

        }else if(hours != null && hours <= 24){
            return hours + " Hours ago";

        }else{
            return days + " days ago"
        }
    }*/

        getNotificationSendTimeInMinutes(createdTimeString) {

        const createdUtc = new Date(createdTimeString.replace(" ", "T") + "Z");
        const nowLocal = new Date();
        const diffMs = nowLocal.getTime() - createdUtc.getTime();

        const minutes = Math.floor(diffMs / (60 * 1000));
        const hours = Math.floor(diffMs / (3600 * 1000));
        const days = Math.floor(diffMs / (24 * 3600 * 1000));
        if (minutes < 1) {
            return "Just now";
        } else if (minutes < 60) {
            return `${minutes} Mins ago`;
        } else if (hours < 24) {
            return `${hours} Hours ago`;
        } else if (hours < 48) {
            return `1 Day ago`;
        } else {
            return `${days} Days ago`;
        }

}

    setView(evt, notificationType, selectedView) {
        window.location.href = "/notification?notification_id=" + evt;
    }


    renderNotifications() {
        let requests = [];
        if (this.state.unreadNotifications === undefined || this.state.unreadNotifications === null) {
            return requests;
        }


        requests = this.state.unreadNotifications.map(val => val.notification_type === "request" || val.notification_type === "request_auto_deleted" ?
            <Dropdown.Item key={val["notification_id"]}
                           className="list-group-item settings-notification"
                           eventKey={val["notification_id"]}
                           onSelect={evt => {this.setView(evt, val.notification_type, val)}}>
                {
                val.notification_type === "request"  ?
                <>
                <div className="notification-icon">
                    <span>
                        <i><FontAwesomeIcon color="#fff" icon={faUserPlus}/></i>
                    </span>
                </div>
                <div className="notification-content">
                    <div className="list-group-item-content">
                        <h5 id={val["notification_id"]}>
                          Invitation Request
                        </h5>
                        <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                    </div>
                    <p> {val["username"]} would like to join your team on Qualdo.</p>
                </div>
                </>
                :
                <>
                <div className="notification-icon">
                    <span>
                        <i><FontAwesomeIcon color="#fff" icon={faUserMinus}/></i>
                    </span>
                </div>
                <div className="notification-content">
                    <div className="list-group-item-content">
                        <h5 id={val["notification_id"]}>
                          Request Auto Deleted
                        </h5>
                        <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                    </div>
                    <p> {val["message"]}</p>
                </div>
                </>
                }
            </Dropdown.Item>
            :
            <Dropdown.Item className="list-group-item app-notification"
                           key={val["notification_id"]}
                           eventKey={val["notification_id"]}
                           onSelect={evt => {
                               this.setView(evt, val.notification_type, val)
                           }}>
                <div className="notification-icon">
                    <span>
                        <i>
                            <FontAwesomeIcon color="#fff"
                                icon={this.getErrorIcon(val.notification_type)}/>
                        </i>
                    </span>
                </div>
                <div className="notification-content">
                    <div className="list-group-item-content">
                        <h5 id={val["notification_id"]}> {val["notification_type"]} </h5>
                        <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                    </div>
                    <p> {getTrimmedNotificationMessage(val)} </p>
                </div>
            </Dropdown.Item>
        );

        return requests;
    }

    closeWarning(){
        this.setState({showWarning: false, warningMessage: null});
    }


    check_access_billing(isDrxFreeTrailExpired) {
        let permissions = decryptForLocalUsage(localStorage.getItem(PERMISSIONS_LOCAL_STORE_KEY))
        let permissionsList = [];
        if (permissions !== undefined && permissions !== null) {
            permissionsList = permissions;
        }
        let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
        let isPlanExpired = ((decrypt_data['isPlanExpired'] === true && decrypt_data['isInBufferPeriod'] === false) ? true : false);
        // let isPlanExpired = ((localStorage.getItem("isPlanExpired") === "true" && localStorage.getItem("isInBufferPeriod") === "false") ? true : false);

        return (
            <>
                {
                    (this.state.featureAccess !== null && this.state.featureAccess["usage_payment"] === false &&
                        permissionsList.includes('BillingAccess') &&!isDrxFreeTrailExpired) ?
                        <>
                            <Dropdown.Item as={Link} to={isPlanExpired ? "/plan" : "/teammate"}
                                activeClassName="active">
                                <i><FontAwesomeIcon icon={faUserFriends} /></i>
                                Team
                            </Dropdown.Item>
                        </>
                        :
                        permissionsList.includes('BillingAccess') && !isDrxFreeTrailExpired ?

                            <>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/plan" :""}
                                    as={Link}
                                    activeClassName="active" >
                                    <i><FontAwesomeIcon icon={faChartPie} /></i>
                                    Plan & Usage
                                </Dropdown.Item>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/choose-plan" :""}
                                    as={Link}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faShoppingBag} /></i>
                                    Upgrade Plan
                                </Dropdown.Item>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/billing" :""}
                                    as={Link}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faHistory} /></i>
                                    Billing & Payment
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to={this.state.prefetch_load !== true ? isPlanExpired ? "/plan" : "/teammate" : ""}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faUserFriends} /></i>
                                    Team
                                </Dropdown.Item>
                            </> : ''
                }
            </>
        );
    }
    shouldComponentUpdate(){
        if(this.state.page === "configure") {
            if(this.state.prefetch_load === true) {
                return false;
            }else {
                return true;
            }
        }else {
            return true;
        }
    }

    componentDidUpdate(prevProps,prevState){
        //Start: Theme DOM Append
        if(prevState.theme !== this.state.theme) {
            localStorage.setItem('theme',this.state.theme);
            document.documentElement.className = this.state.theme;  
        }
        //End: Theme DOM Append

        if(prevProps.page === "configure") {
            if (prevProps.prefetch_load !== this.props.prefetch_load) {
                this.setState({prefetch_load:this.props.prefetch_load});
            }
        }
    }

    clearEnvSearch(){
        this.setState({env_search_text:''});
      }
      getIntegrationStatus = (envLabel) => {
        if (!Array.isArray(this.props.envList)) {
        //   console.error("env_details is not an array:", this.props.envList);
          return false;
        }

        const env = this.props.envList.find(e => e.env_name === envLabel);
        return env ? env.is_integrations : false;
      };

    render() {
        // let {latest_env_name } = this.state;
         let selectedEnv = this.props.selectedEnv
        // const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];
        // let permissions = decryptForLocalUsage(localStorage.getItem(PERMISSIONS_LOCAL_STORE_KEY))
        let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
        let isPlanExpired = ((decrypt_data['isPlanExpired'] === true && decrypt_data['isInBufferPeriod'] === false) ? true : false);
        // let isPlanExpired = ((localStorage.getItem("isPlanExpired") === "true" && localStorage.getItem("isInBufferPeriod") === "false") ? true : false);
        let hideCloseButton = false
        let isDrxFreeTrailExpired = false
        let isDrxFreeTrail = decrypt_data['is_drx_free_trail']
        let DrxFreeTrailStatus = decrypt_data['drx_free_trail_status']
        if (isDrxFreeTrail !== undefined && isDrxFreeTrail !== null && isDrxFreeTrail === true){
            if(DrxFreeTrailStatus !== undefined && DrxFreeTrailStatus !== null && DrxFreeTrailStatus === "Expired"){
                hideCloseButton = true
                isDrxFreeTrailExpired = true
            }
        }

        for (let [key] of Object.entries(activeItems)) {
            activeItems[key] = "nav-item";
        }
        activeItems[this.props.page] = 'nav-item active'

        let warning_message;
        if (this.state.warningMessage !== null) {
            warning_message = this.state.warningMessage;
        }

        let notificationAlertClassName = "";
        let notificationCircleCount = "";

        const currUnreadNotifications = this.state.unreadNotifications;
        const unreadCount = IS_NONE_CHECK.includes(currUnreadNotifications) ? '' : currUnreadNotifications.length;

        if (unreadCount > 0) {
            notificationAlertClassName = "badge alert-badge";
            notificationCircleCount = unreadCount;
        }

        let hideProfileModelTab = true;
        let enableDiscoveryTab = false;
        let enablePowerBiTab = false;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)) {
            const profileModel = this.state.featureAccess["models"];
            const discoverTab = this.state.featureAccess["discover"];
            hideProfileModelTab = profileModel === false;
            enableDiscoveryTab = discoverTab === true;
            const powerbiTab = this.state.featureAccess["powerbi"];
            enablePowerBiTab = powerbiTab === true;
        }

        return (
            <>
                {
                    this.state.showWarning === true ?
                        <WarningMessageHeader warning_message={warning_message} closeWarning={this.closeWarning} hideCloseButton={hideCloseButton}/>
                    : ''
                }


                <header className={this.props.page==="realtime" ? "qd-header sticky-header" : "qd-header"}>
                    <div className="qd-header-container navbar navbar-expand-md">
                        {(SUB_BRAND !== null && SUB_BRAND !== undefined) ?
                            <dt className="title-text"><small >{SUB_BRAND}</small></dt>
                            :
                            ''
                        }
                    <Navbar expand="lg">
                        <Navbar.Brand href={isDrxFreeTrailExpired ? "/discover" : isPlanExpired ? "/plan" : "/configure"}>
                        <div className="qd-header__brand">
                                <Image
                                    className="qd-header__brand-logo-default"
                                    src={BRAND_LOGO}
                                />
                        </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto">
                                <Nav.Item className={activeItems['configure']}>
                                <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/configure")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Configure
                                    </Link>
                                </Nav.Item>
                                {this.state.prefetch_load === true ?
                                <Nav.Item className={activeItems['monitor']}>
                                <Link className="nav-link cursor-progress">
                                        Profile
                                </Link>
                                </Nav.Item>
                                    :
                                    <NavDropdown title="Profile" className={activeItems['profile']}
                                             id="basic-nav-dropdown">
                                    <NavDropdown.Item className={activeItems['data_profile']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/data-profile")}
                                                      tab={this.props.tab}>
                                        <i><FontAwesomeIcon icon={faDatabase}/></i> Data
                                    </NavDropdown.Item>
                                    {hideProfileModelTab ? "" : <NavDropdown.Item className={activeItems['ml-profile']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/ml-profile")}
                                                      tab={this.props.tab}>
                                        <i><FontAwesomeIcon icon={faBezierCurve}/></i>Models
                                    </NavDropdown.Item>
                                    }
                                </NavDropdown> }

                                {/* <Nav.Item className={activeItems['realtime']}>
                                    <Link to={isPlanExpired ? "/plan" :"/realtime"}
                                          className="nav-link">
                                        Monitor
                                    </Link>
                                </Nav.Item> */}

                                {/* <Nav.Item className={activeItems['monitor']}>
                                    {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Monitor
                                    </Link>
                                     :
                                     <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/monitor")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Monitor
                                    </Link>
                                }
                                </Nav.Item> */}

                                  <Nav.Item className={activeItems['realtime']}>
                                    <Link to={isPlanExpired ? "/plan" :"/realtime"}
                                          className="nav-link">
                                        Monitor
                                    </Link>
                                </Nav.Item>

                                <Nav.Item className={activeItems['metrics']}>
                                {this.state.prefetch_load === true ?
                                <Link disabled className="nav-link cursor-progress">
                                        Metrics
                                    </Link>
                                    :
                                    <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/metrics")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Metrics
                                    </Link>
                                }
                                </Nav.Item>
                                <Nav.Item className={activeItems['alerts']}>
                                {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Alerts
                                    </Link>
                                    :
                                    <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/alerts")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Alerts
                                     </Link>
                                }
                                </Nav.Item>
                                { enableDiscoveryTab?
                                <Nav.Item className={activeItems['discover']}>
                                    {/* {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Discover
                                    </Link>
                                    : */}
                                    <Link to={isPlanExpired ? "/plan" :"/discover"}
                                          className="nav-link">
                                        Discover
                                    </Link>
                                    {/* } */}
                                </Nav.Item>
                                :
                                ''
                                }


                                 <Nav.Item className={activeItems['incidents']}>
                                {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">Incidents <span class="dot-circle dot-circle--primary"></span></Link>
                                    :
                                    <Link to={"/incidents"} className="nav-link ">Incidents <span class="dot-circle dot-circle--primary"></span></Link>
                                }
                                </Nav.Item>
                                 { enablePowerBiTab
                                ?
                <NavDropdown title="Power BI" className={activeItems['powerbi']}
                                             id="basic-nav-dropdown">
                                    <NavDropdown.Item className={activeItems['pbi-setup']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" :"/pbi-setup"}
                                                      tab={this.props.tab}>
                                        <i className='icon_powerbi'></i>Power BI Setup
                                    </NavDropdown.Item>
                                     <NavDropdown.Item className={activeItems['pbi-report']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" :"/pbi-report"}
                                                      tab={this.props.tab}>
                                        <i className='icon_powerbi-error'></i>Power BI Error
                                    </NavDropdown.Item>
                                    {/* JIRA ISSUE QPS-2153 <NavDropdown.Item className={activeItems['pbi-mapping']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" :"/pbi-mapping"}
                                                      tab={this.props.tab}>
                                        <i className='icon_powerbi-mapping'></i>Power BI Mapping
                                    </NavDropdown.Item> */}
                                </NavDropdown>
                                :"" }
                            </Nav>
                           {(this.props.page === "incidents" || this.props.page === "discover" || this.props.page === "profile" || this.props.page === "monitor" || this.props.page === "realtime") && <div className="qd-header__topbar-item qd-env-dropdown">
                                    <Dropdown alignRight>
                                        <Dropdown.Toggle as={envToggle} selectedEnv={selectedEnv} latestEnvName={this.props.page === "realtime" || this.props.page === "incidents" ? this.props.selectedEnvName: this.props.latest_env_name}/>
                                        <Dropdown.Menu>
                                            <div className="qd-env-dropdown-menu__head">
                                                <div className="qd-search-bar">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <button id="button-addon4" type="button" className="btn"><FontAwesomeIcon icon={faSearch} /></button>
                                                        </div>
                                                        <input type="search" placeholder="Search..." className="form-control"  onChange={this.handleEnvSearchChange} value={this.state.env_search_text}/>
                                                    </div>
                                                    {this.state.env_search_text && <button className="btn btn-clear" title="clear"><i className="icon-close" onClick={this.clearEnvSearch} value={this.state.env_search_text}></i></button>}
                                                </div>
                                            </div>
                                            <div className="qd-env-dropdown-menu__body">
                                                <Dropdown.Header>Environment</Dropdown.Header>
                                                { this.props.cachenable === true ?
                                                    this.state.env_search_text === "" ? ((this.state.environment !== undefined ||this.state.environment !== null) && this.state.environment && this.state.environment.length > 0 ? (this.state.environment.map((env, index) => (
                                                        <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`}    onClick={() =>  this.handleEnvSelect(env, index, this.props.selectedEnvName)}  style={{pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto',opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1,cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer',}} disabled={!this.getIntegrationStatus(env.label)} >
                                                        <span className="env-tag" style={{backgroundColor:colors[index % colors.length],}}>
                                                            {env.label[0].toUpperCase()}
                                                        </span>
                                                        <span className="menu-text">{env.label}</span>
                                                        </Dropdown.Item>
                                                    ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)) : this.state.filteredEnv !== undefined && this.state.filteredEnv.length > 0 ? (
                                                    this.state.filteredEnv.map((env, index) => (
                                                    <Dropdown.Item  className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`}   onClick={() => this.handleEnvSelect(env, index, this.props.selectedEnvName)}  style={{pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto',opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1,cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer',}}disabled={!this.getIntegrationStatus(env.label)}>
                                                        <span className="env-tag" style={{backgroundColor: colors[index % colors.length],}}>
                                                        {env.label[0].toUpperCase()}
                                                        </span>
                                                        <span className="menu-text">{env.label}</span>
                                                    </Dropdown.Item>
                                                    ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>)
                                                 :
                                                this.props.discoverCache === true ? this.props.search_text === "" ? ((this.state.environment !== undefined ||this.state.environment !== null) && this.state.environment && this.state.environment.length > 0 ? (this.state.environment.map((env, index) => (
                                                        <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`}    onClick={() =>  this.props.handleSelect(env, index, this.props.selectedEnvName)}  style={{pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto',opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1,cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer',}} disabled={!this.getIntegrationStatus(env.label)} >
                                                    <span className="env-tag" style={{backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length],}}>
                                                        {env.label[0].toUpperCase()}
                                                    </span>
                                                    <span className="menu-text">{env.label}</span>
                                                    </Dropdown.Item>
                                                    ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)) : this.props.filteredEnv !== undefined && this.props.filteredEnv.length > 0 ? (
                                                    this.props.filteredEnv.map((env, index) => (
                                                    <Dropdown.Item  className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`}   onClick={() => this.props.handleSelect(env, index, this.props.selectedEnvName)}  style={{pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto',opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1,cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer',}}disabled={!this.getIntegrationStatus(env.label)}>
                                                    <span className="env-tag" style={{backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length],}}>
                                                    {env.label[0].toUpperCase()}
                                                    </span>
                                                    <span className="menu-text">{env.label}</span>
                                                </Dropdown.Item>
                                                    ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>) 
                                                : this.props.search_text === "" ? (Array.isArray(this.props.environment) && this.props.environment.length > 0 ? (this.props.environment.sort((a, b) => b.integration_ids.length - a.integration_ids.length).map((env, index) => (
                                                    <Dropdown.Item className={`dropdown-item--all ${env.integration_ids.length === 0 ? "disabled" : ""}${this.props.selectedEnvName === env.label ? 'active' : ''}`} style={{pointerEvents: env.integration_ids.length === 0 ? 'none' : 'auto',opacity: env.integration_ids.length === 0 ? 0.5 : 1,cursor: env.integration_ids.length === 0 ? 'not-allowed' : 'pointer',}} onClick={() => env.integration_ids.length > 0 && this.props.handleSelect(env, index, this.props.latest_env_name)}>
                                                    <span className="env-tag" style={{backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length],}}>
                                                        {env.label[0].toUpperCase()}
                                                    </span>
                                                    <span className="menu-text">{env.label}</span>
                                                    </Dropdown.Item>
                                                ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>)) : this.props.filteredEnv !== undefined && this.props.filteredEnv.length > 0 ? (
                                                this.props.filteredEnv.sort((a, b) => b.integration_ids.length - a.integration_ids.length).map((env, index) => (
                                                <Dropdown.Item className={`dropdown-item--all ${env.integration_ids.length === 0 ? "disabled" : ""}${this.props.selectedEnvName ===env.label ? 'active':''}`} style={{pointerEvents: env.integration_ids.length === 0 ? 'none' : 'auto',opacity: env.integration_ids.length === 0 ? 0.5 : 1,cursor: env.integration_ids.length === 0 ? 'not-allowed' : 'pointer',}}onClick={() => env.integration_ids.length > 0 && this.props.handleSelect(env, index, this.props.latest_env_name)}>
                                                    <span className="env-tag" style={{backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length],}}>
                                                    {env.label[0].toUpperCase()}
                                                    </span>
                                                    <span className="menu-text">{env.label}</span>
                                                </Dropdown.Item>
                                                ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>}
                            {this.props.page !== "discover" && enableDiscoveryTab ? <div className="qd-header__topbar-item qd-quick-search d-none d-xl-inline-block">
                                {/* <form className="qd-quick-search__form" onKeyDown={this.onKeyDownHandler}>
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text"><i><FontAwesomeIcon icon={faSearch}/></i></span>
                                    </div>
                                    <input type="text" ref={n => this.input = n} className="form-control qd-quick-search__input" placeholder="Search..."/>
                                  </div>
                                </form> */}
                                <form className="qd-quick-search__form" onKeyDown={this.onKeyDownHandler}>
                                  <div className="input-group">
                                    <input type="text" ref={n => this.input = n} className="form-control qd-quick-search__input" placeholder="Search..."/>
                                  </div>
                                </form>
                            </div> : ""}
                            <div className="qd-header__topbar-item d-md-none d-lg-inline-block">
                                <div className="qd-header__topbar-wrapper">
                                 <div className="qd-header__topbar-icon"
                                            onClick={this.handleHelp}>
                                            <span className="nav-link" onClick={this.handleHelp}>
                                                {/* <FontAwesomeIcon onClick={this.handleHelp} color="#fff" icon={faQuestion} /> */}
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0017 22C10.6877 22 9.45267 21.7507 8.2965 21.252C7.14033 20.7533 6.13467 20.0766 5.2795 19.2218C4.42433 18.3669 3.74725 17.3617 3.24825 16.206C2.74942 15.0503 2.5 13.8156 2.5 12.5017C2.5 11.1877 2.74933 9.95267 3.248 8.7965C3.74667 7.64033 4.42342 6.63467 5.27825 5.7795C6.13308 4.92433 7.13833 4.24725 8.294 3.74825C9.44967 3.24942 10.6844 3 11.9983 3C13.3123 3 14.5473 3.24933 15.7035 3.748C16.8597 4.24667 17.8653 4.92342 18.7205 5.77825C19.5757 6.63308 20.2528 7.63833 20.7518 8.794C21.2506 9.94967 21.5 11.1844 21.5 12.4983C21.5 13.8123 21.2507 15.0473 20.752 16.2035C20.2533 17.3597 19.5766 18.3653 18.7218 19.2205C17.8669 20.0757 16.8617 20.7528 15.706 21.2518C14.5503 21.7506 13.3156 22 12.0017 22ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z" fill="white"/>
                                                    <path d="M11.4032 12.7211C11.8967 11.8432 12.8452 11.3253 13.3963 10.5484C13.9795 9.73368 13.6527 8.21158 11.9992 8.21158C10.9161 8.21158 10.3842 9.02 10.1599 9.68947L8.5 9.00105C8.95503 7.65579 10.1919 6.5 11.9928 6.5C13.4989 6.5 14.5307 7.17579 15.0562 8.02211C15.5049 8.74842 15.7676 10.1063 15.0755 11.1168C14.3064 12.2347 13.5694 12.5758 13.172 13.2958C13.0118 13.5863 12.9477 13.7758 12.9477 14.7105H11.0956C11.0892 14.2179 11.0123 13.4158 11.4032 12.7211ZM13.281 17.2368C13.281 17.9316 12.7042 18.5 11.9992 18.5C11.2943 18.5 10.7175 17.9316 10.7175 17.2368C10.7175 16.5421 11.2943 15.9737 11.9992 15.9737C12.7042 15.9737 13.281 16.5421 13.281 17.2368Z" fill="white"/>
                                                </svg>
                                            </span>
                                        </div>   
                                </div>
                                {this.state.zendeskShow === true ? <HelpZendesk/> : ""}
                            </div>
                            <div className="qd-header__topbar-item dropdown d-lg-inline-block qd-header_notification">
                                <div className="qd-header__topbar-wrapper dropdown"
                                    id = "dropdown__user-notification"
                                    key={`user_notification_${notificationCircleCount}`}
                                >

                                    <Dropdown>
                                        <Dropdown.Toggle unReadMsg={currUnreadNotifications} as={bellToggle} />
                                        <span className={notificationAlertClassName}
                                            key={`notificationCircle${notificationCircleCount}`}>
                                            {notificationCircleCount}
                                        </span>
                                        { this.state.prefetch_load !== true && currUnreadNotifications !== null && (isPlanExpired !== true && isDrxFreeTrailExpired !== true)?
                                        <Dropdown.Menu className="dropdown-menu__user-notification has-caret" popper={false} ref={(el) => {if (el) {el.style.margin = ''; }}}>
                                                <Dropdown.Item className="dropdown-menu_user-notification__head">
                                                    <span>
                                                        {currUnreadNotifications.length} New Qualdo Notifications
                                                    </span>
                                                </Dropdown.Item>

                                                <div className="user-notification__list">
                                                    {this.renderNotifications()}
                                                </div>

                                                <Dropdown.Item className="dropdown-menu_user-notification__footer"
                                                            name='view all'
                                                            href='/notification'>
                                                    View All Notifications
                                                    <i>
                                                        <FontAwesomeIcon icon={faArrowRight}/>
                                                    </i>
                                                </Dropdown.Item>
                                            </Dropdown.Menu> : ""
                                        }
                                    </Dropdown>


                                </div>
                            </div>
                            <div className="qd-header__topbar-item d-none">
                                <div className="qd-header__topbar-wrapper">
                                    <div className="qd-header__topbar-icon" onClick={this.handleShowAiAssistant}>
                                        <span className="nav-link">
                                            <svg className='d-block' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="24" height="24" fill="none"/>
                                                <path d="M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM21.988 10.966L19.667 9.074L20.877 7.314C21.471 8.425 21.845 9.657 21.988 10.966ZM9.283 10.526C9.184 10.834 9.063 11.142 8.92 11.461C8.414 12.627 7.776 13.606 7.105 14.409C7.05 14.145 7.006 13.881 6.962 13.606C6.654 11.505 6.808 9.602 7.16 7.985C7.534 8.106 7.93 8.238 8.337 8.403L9.283 10.537V10.526ZM8.953 8.645C9.195 8.744 9.448 8.865 9.701 8.986C9.646 9.283 9.569 9.58 9.481 9.888L8.953 8.645ZM9.47 11.692C9.525 11.571 9.591 11.45 9.635 11.318L11.483 15.498C10.515 16.752 9.547 17.808 8.634 18.71C8.084 17.665 7.567 16.422 7.237 14.992C8.04 14.112 8.832 13.023 9.47 11.692ZM9.866 10.768C10.064 10.273 10.207 9.789 10.328 9.305C10.823 9.558 11.318 9.855 11.824 10.174C11.901 10.812 12.055 11.483 12.286 12.165C12.451 12.66 12.649 13.122 12.869 13.551C12.495 14.112 12.132 14.64 11.747 15.146L9.866 10.768ZM13.683 10.064C13.254 9.767 12.825 9.503 12.396 9.261C12.319 7.49 12.704 5.917 13.155 4.707L16.037 7.226C15.641 8.304 15.146 9.47 14.53 10.669C14.255 10.471 13.98 10.262 13.683 10.064ZM13.947 11.769C13.771 12.099 13.573 12.429 13.375 12.759C13.331 12.825 13.287 12.902 13.243 12.968C13.144 12.726 13.045 12.484 12.968 12.231C12.792 11.703 12.66 11.186 12.572 10.691C12.638 10.735 12.704 10.779 12.77 10.834C13.188 11.142 13.584 11.461 13.958 11.78L13.947 11.769ZM13.496 14.662C13.749 15.058 14.024 15.432 14.321 15.762L12.935 17.907L12.231 16.268C12.649 15.762 13.078 15.223 13.496 14.651V14.662ZM13.837 14.189C14.101 13.815 14.365 13.419 14.629 13.023C14.717 12.891 14.794 12.759 14.871 12.627C15.19 12.935 15.487 13.243 15.762 13.551L14.607 15.333C14.332 14.981 14.079 14.596 13.837 14.189ZM15.542 11.494C16.191 10.361 16.73 9.261 17.17 8.227L18.468 9.371L16.521 12.385C16.224 12.088 15.894 11.791 15.553 11.494H15.542ZM19.095 9.921L21.438 11.978C20.613 12.473 19.469 13.298 18.501 14.618C18.083 14.068 17.599 13.485 17.038 12.902L19.095 9.91V9.921ZM18.435 4.718C18.479 4.597 18.501 4.487 18.534 4.377C19.128 4.872 19.656 5.444 20.107 6.071C20.195 6.192 20.283 6.313 20.36 6.423L19.007 8.513L17.544 7.314C17.907 6.379 18.204 5.499 18.435 4.707V4.718ZM16.092 2.837C16.466 3.002 16.818 3.189 17.17 3.398C17.148 3.486 17.126 3.574 17.115 3.651C16.928 4.454 16.686 5.356 16.345 6.346L13.452 3.992C13.848 3.112 14.244 2.496 14.409 2.243C14.992 2.386 15.553 2.573 16.092 2.826V2.837ZM12 1.957C12.583 1.957 13.166 2.012 13.716 2.111C13.551 2.364 13.243 2.859 12.913 3.552L11.01 2.001C11.34 1.968 11.659 1.957 12 1.957ZM10.229 2.122L12.627 4.234C12.132 5.433 11.692 7.039 11.725 8.887C11.329 8.678 10.933 8.491 10.548 8.315C11.054 5.433 10.46 2.969 10.229 2.133V2.122ZM9.349 2.694C9.602 3.497 10.152 5.51 9.855 8.007C9.382 7.809 8.909 7.644 8.458 7.49L7.765 5.873C8.304 4.366 9.019 3.211 9.349 2.683V2.694ZM7.534 6.566L7.864 7.314C7.688 7.259 7.523 7.215 7.358 7.171C7.413 6.962 7.479 6.764 7.534 6.566ZM7.171 3.2C7.094 3.365 6.995 3.585 6.885 3.849L6.72 3.475C6.863 3.376 7.017 3.288 7.171 3.211V3.2ZM6.28 3.75L6.61 4.509C6.379 5.136 6.126 5.928 5.917 6.841C5.477 6.753 5.059 6.687 4.685 6.632C4.685 6.06 4.641 5.576 4.586 5.224C5.092 4.674 5.653 4.179 6.269 3.75H6.28ZM4.289 9.162C4.498 8.513 4.608 7.908 4.663 7.347C5.004 7.413 5.378 7.49 5.785 7.589C5.411 9.602 5.312 12.11 6.016 14.86C6.06 15.047 6.115 15.234 6.17 15.421C5.675 15.894 5.202 16.29 4.762 16.598L2.628 12.11C3.222 11.417 3.882 10.438 4.3 9.151L4.289 9.162ZM4.058 5.862C4.08 6.071 4.102 6.302 4.102 6.566C3.926 6.544 3.75 6.533 3.596 6.522C3.739 6.291 3.893 6.071 4.069 5.862H4.058ZM3.211 7.138C3.464 7.16 3.75 7.204 4.08 7.248C4.047 7.831 3.937 8.491 3.728 9.195C3.398 10.262 2.914 11.12 2.452 11.769L2.023 10.867C2.166 9.525 2.584 8.26 3.211 7.138ZM1.968 12.22L2.023 12.319C2.023 12.319 1.99 12.352 1.979 12.374C1.979 12.319 1.979 12.275 1.979 12.22H1.968ZM1.99 12.759C2.045 12.715 2.1 12.66 2.155 12.594L4.344 16.873C4.036 17.082 3.761 17.247 3.53 17.379C2.661 16.026 2.122 14.453 1.99 12.77V12.759ZM3.75 17.72C3.981 17.599 4.245 17.434 4.542 17.247L5.95 20.008C5.103 19.37 4.366 18.589 3.761 17.72H3.75ZM6.577 20.448L4.927 16.983C5.356 16.686 5.818 16.334 6.302 15.905C6.731 17.247 7.303 18.413 7.897 19.414C7.457 19.821 7.039 20.173 6.654 20.503C6.632 20.503 6.61 20.481 6.577 20.459V20.448ZM7.435 20.943C7.732 20.701 8.051 20.448 8.381 20.162C8.788 20.767 9.195 21.295 9.58 21.735C8.832 21.548 8.117 21.284 7.446 20.932L7.435 20.943ZM9.107 19.524C10.009 18.699 10.988 17.731 11.967 16.587L12.715 18.259L10.57 21.57C10.13 21.042 9.613 20.36 9.107 19.524ZM12 22.043C11.637 22.043 11.274 22.021 10.911 21.988C10.878 21.988 10.845 21.988 10.812 21.977L10.845 21.922L12.957 18.853L14.255 21.79C13.529 21.955 12.77 22.043 11.989 22.043H12ZM16.543 20.954C15.916 21.273 15.256 21.526 14.574 21.702L13.199 18.512L14.761 16.246C15.476 16.994 16.224 17.577 16.884 18.017C16.576 19.183 16.532 20.228 16.554 20.954H16.543ZM15.025 15.85L16.224 14.09C16.774 14.75 17.236 15.399 17.632 16.015C17.346 16.576 17.126 17.126 16.972 17.654C16.334 17.181 15.652 16.587 15.025 15.861V15.85ZM17.214 20.58C17.247 20.052 17.335 19.304 17.577 18.446C18.303 18.864 18.853 19.073 19.04 19.15C18.49 19.689 17.874 20.173 17.203 20.569L17.214 20.58ZM19.205 18.985C19.205 18.985 19.194 18.952 19.183 18.93C18.809 18.765 18.281 18.501 17.676 18.127C17.808 17.731 17.973 17.324 18.182 16.906C18.633 17.698 18.963 18.391 19.183 18.93C19.205 18.93 19.216 18.941 19.227 18.952C19.227 18.963 19.216 18.974 19.205 18.985ZM19.095 15.443C20.107 14.123 21.262 13.364 21.988 12.968C21.834 14.64 21.262 16.202 20.371 17.544C20.063 16.972 19.645 16.246 19.095 15.443Z" fill="white"/>
                                            </svg>
                                        </span>
                                    </div>   
                                </div>
                            </div>
                        <div className="qd-header__topbar-item qd-header__topbar-item--user">
                            <div className="qd-header__topbar-wrapper dropdown">
                                <span className="qd-header__topbar-welcome">Hi,</span>
                                <span className="qd-header__topbar-username">
                                    {localStorage.getItem('user_name')}
                                </span>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle as={userToggle}>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                           <Dropdown.Item onClick={this.state.prefetch_load !== true ? this.onItemClick :""}  to={isDrxFreeTrailExpired === true ? "" :this.state.prefetch_load!== true ? "/settings" :""}  as={Link} activeClassName="active"><i><FontAwesomeIcon
                                            icon={faUserCog}/></i>Profile</Dropdown.Item>
                                             <Dropdown.Item href={get_document_link("index")} target="_blank">
                                            <i><FontAwesomeIcon icon={faBook}/></i>{QUALDO_DOCUMENTATION}
                                        </Dropdown.Item>
                                            <DropdownButton
                                               className="d-none"
                                                drop="left"
                                                variant=" "
                                                title={
                                                    <>{this.state.theme === "light" ? <FontAwesomeIcon icon={faSun} /> : <FontAwesomeIcon icon={faMoon} />} Mode</>
                                                }
                                            >

                                                <Dropdown.Item className={(this.state.theme === 'light' && this.state.themeSystem === '') ? 'active' : ''} onClick={() => this.toggleTheme("light")}><i><FontAwesomeIcon icon={faSun} /></i>Light</Dropdown.Item>
                                                <Dropdown.Item className={(this.state.theme === 'dark' && this.state.themeSystem === '') ? 'active' : ''} onClick={() => this.toggleTheme("dark")}><i><FontAwesomeIcon icon={faMoon} /></i>Dark</Dropdown.Item>
                                                <Dropdown.Item className={this.state.themeSystem === 'system' ? 'active' : ''} onClick={() => this.setSystemTheme()}><i><FontAwesomeIcon icon={faDesktop} /></i>System</Dropdown.Item>
                                            </DropdownButton>
                                        {this.check_access_billing(isDrxFreeTrailExpired)}
                                        <Dropdown.Item name='logout'
                                                       onClick={handleClick.bind(this)}>
                                            <i><FontAwesomeIcon icon={faSignOutAlt}/></i>
                                            Log Out
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        </Navbar.Collapse>
                    </Navbar>


                </div>
                {/* <Offline polling={false} interval={1000} onChange={this.pageRefresh}>
                    <OfflineComponent>
                    </OfflineComponent>
                </Offline> */}
                {this.props.loader !== undefined &&this.props.loader!==null &&this.props.loader === true &&
                    <ProgressLoader modifierClass={this.props.loader==="incidents" ? "progress-loader--light" : "progress-loader--danger"} /> /* menu name chceck  "progress-loader--danger" add this classname for incident management */
                }
                <NetworkStatusAlert />
                {/* <AiAssistant open={this.state.showAiAssistant} onAiAssistantClose={this.handleHideAiAssistant} /> */}
            </header>
            </>
        );
    }
}


const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps, null) (NavigationHeader);


export function SimpleHeader() {
    let DataSetupStatus = localStorage.getItem("DataSetupStatus");
    const canShowQuickStart = DataSetupStatus !== "false";
    let BRAND_LOGO = process.env.REACT_APP_CUSTOM_BRAND_LOGO

    let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
    let warning_message = decrypt_data['warning_message']
    // let warning_message = localStorage.getItem("warning_message");

    let showWarning = false;
    if (warning_message !== undefined && warning_message !== null && warning_message !== '' && warning_message !== 'undefined') {
        showWarning = true;
    }

    return (
        <>
        {
                    showWarning === true ?
                        <WarningMessageHeader warning_message={warning_message} quick_start={true} />
                    : ''
                }

        <header className="qd-header">
            <div className="qd-header-container navbar navbar-expand-md">
                {(SUB_BRAND !== null && SUB_BRAND !== undefined) ?
                    <dt className="title-text"><small >{SUB_BRAND}</small></dt>
                    :
                    ''
                }
                <div className="qd-header__brand">
                    <a href="#!">
                        <Image
                            className="qd-header__brand-logo-default"
                            src={BRAND_LOGO}
                        />
                    </a>
                </div>
                <button className="navbar-toggler collapsed" type="button"
                    data-toggle="collapse" data-target="#navbarCollapse"
                    aria-controls="navbarCollapse" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="navbar-collapse collapse flex-row-reverse" id="navbarCollapse">
                    <div className="qd-header__topbar-item qd-header__topbar-item--user">
                        <div className="qd-header__topbar-wrapper dropdown">
                            <span className="qd-header__topbar-welcome">Hi,</span>
                            <span className="qd-header__topbar-username">
                                {localStorage.getItem('user_name')}
                            </span>
                            <Dropdown alignRight>
                                <Dropdown.Toggle as={userToggle}>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item href="/settings">
                                        <i><FontAwesomeIcon icon={faUserCog} /></i>Profile
                                    </Dropdown.Item>

                                        {
                                            canShowQuickStart ?
                                            <Dropdown.Item href="/quick-start"><i>
                                                <FontAwesomeIcon icon={faRocket}/></i>Quick Start
                                            </Dropdown.Item>
                                            :
                                            ''
                                        }

                                        <Dropdown.Item href={get_document_link("index")} target="_blank">
                                            <i><FontAwesomeIcon icon={faBook}/></i>{QUALDO_DOCUMENTATION}
                                        </Dropdown.Item>
                                        <Dropdown.Item name='logout'
                                                       onClick={handleClick.bind(this)}>
                                            <i><FontAwesomeIcon icon={faSignOutAlt}/></i>
                                            Log Out
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            {/* <Offline polling={false} interval={1000} onChange={this.pageRefresh}>
                <OfflineComponent>
                </OfflineComponent>
            </Offline> */}
            </header>
            </>
        );

}
